import React from 'react';
import { DealerData, VehicleData } from '../types';

interface DetailsContext {
  vehicle?: VehicleData,
  dealer?: DealerData
};

export const VehicleDetailsContext = React.createContext<DetailsContext>({});
